
import EmailGeneral from './General/Index'
import EmailStopSale from './StopSale/Index'
import EmailHistory from './EmailHistory/List'

export default [
  {
    path: 'general',
    name: 'EmailGeneral',
    component: EmailGeneral
  },
  {
    path: 'stop-sale',
    name: 'EmailStopSale',
    component: EmailStopSale
  },
  {
    path: 'email-history',
    name: 'EmailHistory',
    component: EmailHistory
  }
]
